<template>
  <component :is="isMobile ? 'ExpensesViewMobile' : 'ExpensesViewDesktop'" />
</template>

<script>
import ExpensesViewDesktop from '@/components/expenses/ExpensesViewDesktop.vue'
import ExpensesViewMobile from '@/components/expenses/ExpensesViewMobile.vue'

export default {
  components: {
    ExpensesViewDesktop,
    ExpensesViewMobile,
  },
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.checkScreen()
    window.addEventListener('resize', this.checkScreen)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreen)
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768
    },
  },
}
</script>
